import WeatherIcon from './WeatherIcon'
import './HourlyForecastWidget.css'
import { useContext } from 'react'
import WeatherContext from './WeatherContext'

const HourlyForecastWidget = ({ data }) => {
  const {units} = useContext(WeatherContext)
  const { date, icon, summary, temperature, precipitation, wind } = data

  const locale = navigator.language;
  const now_date = {
    day: new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit',
    }).format(new Date()),
    time: new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date().setMinutes(0)),
  };
  const weather_date = {
    day: new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit',
    }).format(new Date(date)),
    time: new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(date).setMinutes(0)),
  };
  const midnightTime = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date().setHours(0, 0, 0, 0));

  weather_date.day =
    weather_date.day === now_date.day &&
    weather_date.time === now_date.time
      ? 'Now'
      : weather_date.time === midnightTime
      ? weather_date.day
      : '';


  return (
    <div className="hourly-widget">
      <div className="day">{weather_date.day}</div>
      <div className="time">{weather_date.time}</div>
      <div className="icon-temp">
        <div className="icon">
          <WeatherIcon iconNumber={icon} alt={summary} />
        </div>
        <div className="temp">{Math.floor(temperature)} {units.temperature}</div>
        <div className="precipitation">{Math.floor(precipitation.total)} {units.precipitation}</div>
        <div className="wind">
          <div className="speed">{Math.floor(wind.speed)} {units.wind_speed}</div>
          <div className="dir">
            <i
              className="bi bi-send-fill"
              style={{ transform: `rotate(${-45 + wind.angle}deg)` }}
            ></i>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HourlyForecastWidget
